module.exports = __webpack_public_path__ + "img/setting.7c5ba376.svg";